import { AbstractModel, JsonObject, JsonProperty, DateConverter } from 'projects/core/src/public-api';

@JsonObject('FeedBackType')
export class FeedBackType extends AbstractModel {

    @JsonProperty(String, 'value')
    value?: string;

    @JsonProperty(String, 'title')
    title?: string;

}